import { Mic, Send } from "lucide-react";
import { TURNSTILE_REQUIRED } from "@/lib/api";
import { useAskForm } from "@/hooks/useAskForm";
import TurnstileWidget from "@/components/TurnstileWidget";
import { AskPitch, GuestChip, AskError, AskSuccess } from "@/components/atfq/AskParts";
import { AskFields } from "@/components/atfq/AskFields";


export const AskAQuestion = () => {
  const { form, guest, setGuest, status, setField, toggleField, onSubmit, turnstile } = useAskForm();

  return (
    <div
      id="atfq-ask"
      data-testid="atfq-ask-section"
      className="mt-28 md:mt-32 border-t border-slate-200 pt-16"
    >
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <AskPitch />

        {/* Form column */}
        <form
          onSubmit={onSubmit}
          data-testid="atfq-ask-form"
          className="lg:col-span-7 bg-slate-50 border border-slate-200 p-6 md:p-8 space-y-5"
          noValidate
        >
          {guest && <GuestChip guest={guest} onClear={() => setGuest(null)} />}
          <AskFields form={form} guest={guest} setField={setField} toggleField={toggleField} />

          {TURNSTILE_REQUIRED && (
            <div className="pt-2">
              <TurnstileWidget
                onToken={turnstile.onToken}
                onError={turnstile.onError}
              />
            </div>
          )}

          {status.state === "error" && <AskError message={status.message} />}

          {status.state === "success" ? (
            <AskSuccess message={status.message} />
          ) : (
            <button
              type="submit"
              data-testid="atfq-ask-submit"
              disabled={status.state === "loading"}
              className="w-full sm:w-auto inline-flex items-center justify-center gap-3 bg-[var(--accent)] hover:bg-[#3b7bd0] disabled:opacity-50 disabled:cursor-not-allowed text-white px-6 py-3.5 text-sm font-medium tracking-tight transition-colors"
            >
              {status.state === "loading" ? (
                <>
                  <Mic className="w-4 h-4 animate-pulse" />
                  Sending…
                </>
              ) : (
                <>
                  <Send className="w-4 h-4" />
                  Send to ATFQ
                </>
              )}
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default AskAQuestion;
